import React from 'react';
import AdminWhatsappDashboard from '../../components/AdminWhatsappDashboard';

function EnviosWhatsapp() {
  return (
    <div>
      <h1>Envíos WhatsApp</h1>
      <AdminWhatsappDashboard />
    </div>
  );
}

export default EnviosWhatsapp;
